import get from 'lodash/get';
import DatadogHandler from 'utils/datadog';
import { FEATURE_FLAGS } from 'utils/constants';
import {
  msGetRegAdditionalInfo,
  msSaveRegAdditionalInfo,
} from 'services/RegistrationsService';
import { SkApolloRequest } from '../../../utils/apolloUtils';
import { GET_REG_ADDITIONAL_INFORMATION } from '../actionTypes';
import {
  GET_REG_ADDITIONAL_INFO,
  SET_REG_ADDITIONAL_INFO,
  FETCH_APPLICANT_CHANGES,
} from '../../models/Registration/aditionalInfomodels';
import {
  actionHandlerWithFeatureFlag,
  parseGraphQLError,
} from '../../../utils';
import { msGetApplicantChanges } from '../../../services/RegistrationsService';

const fileName = 'redux/actions/Registration/additionialInfoV2.js';

const dispatchGetRegAdditionalInfo = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: GET_REG_ADDITIONAL_INFORMATION,
    key: 'regAdditionalInfo',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

export const monoFetchRegAdditionalInfo = async (_, reqData) => {
  try {
    const regID = get(reqData, 'regID');
    const result = await SkApolloRequest({
      params: {
        query: GET_REG_ADDITIONAL_INFO,
        variables: {
          registrationID: regID,
        },
      },
      type: 'query',
    });
    return result;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchRegAdditionalInfo',
        fileName: 'src/redux/actions/Registration/additionialInfoV2.js',
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const fetchRegAdditionalInfo = regID => async dispatch => {
  dispatchGetRegAdditionalInfo(dispatch);

  const resp = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msGetRegAdditionalInfo,
      monoHandler: monoFetchRegAdditionalInfo,
      extraData: { regID },
    }
  );

  if (resp.success) {
    dispatchGetRegAdditionalInfo(dispatch, false, resp);
  } else {
    dispatchGetRegAdditionalInfo(dispatch, false, null, resp.error);
  }
  return resp;
};

export const monoSaveRegAdditionalInfo = async (_, reqData) => {
  try {
    const result = await SkApolloRequest({
      params: {
        mutation: SET_REG_ADDITIONAL_INFO,
        variables: reqData,
      },
      type: 'mutation',
    });

    return result;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoSaveRegAdditionalInfo',
        fileName: 'src/redux/actions/Registration/additionialInfoV2.js',
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const saveRegAdditionalInfo = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msSaveRegAdditionalInfo,
      monoHandler: monoSaveRegAdditionalInfo,
      extraData: reqData,
    }
  );
};

export const monoGetApplicantChanges = async (_, { IDRegChild }) => {
  try {
    const result = await SkApolloRequest({
      params: {
        query: FETCH_APPLICANT_CHANGES,
        variables: { IDRegChild },
      },
      type: 'query',
    });

    return result;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetApplicantChanges',
        fileName,
      },
      'error'
    );
    return { error: ex?.message };
  }
};

export const getApplicantChanges = IDRegChild => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msGetApplicantChanges,
    monoHandler: monoGetApplicantChanges,
    extraData: { IDRegChild },
  });
